import { useStaticQuery, graphql } from "gatsby"

export const useBlogPrevNextTextQuery = () => {
  const { wp } = useStaticQuery(
    graphql`
    query BlogPrevNextTextQuery {
        wp {
          acfOptionsCommonItems {
            commonItems {
              commonItemsBlogPostPrevText
              commonItemsBlogPostNextText
            }
          }
        }
      }
    `
  )
  return wp.acfOptionsCommonItems.commonItems
}
